import React from "react";
import BaseElement from "components/FormElements/BaseElement";

export default function Text(props) {
    const defaultProps = {
        label: "Text",
        id: "text",
        name: "text",
        type: "text",
        value: "",
        variant: false,
    };
    const useProps = Object.assign(defaultProps, {}, props);

    const label = (
        <label
            htmlFor={useProps.id}
            className="block text-sm font-medium text-gray-700"
        >
            {props.label}
        </label>
    );

    const input = (
        <div className="w-full sm:text-sm">
            {useProps.value}
            {useProps.children}
        </div>
    );

    return <BaseElement {...useProps} label={label} input={input} />;
}
